// extracted by mini-css-extract-plugin
export var container = "HorizontalOverflowWrapper-module--container--9613d";
export var right = "HorizontalOverflowWrapper-module--right--cf7e6";
export var scrollButton = "HorizontalOverflowWrapper-module--scrollButton--186cf";
export var wrapper = "HorizontalOverflowWrapper-module--wrapper--f00c0";